/** Party has a non-empty GSTIN */
export function partyHasGst(party) {
  return Boolean((party?.gstin || "").trim());
}

/** Match general search: name, mobile, address (English + Gujarati Unicode), city, state, etc. */
export function partyMatchesGeneralSearch(party, query) {
  const q = (query || "").trim();
  if (!q) return true;
  const qLower = q.toLowerCase();
  const fields = [
    party.companyName,
    party.partyName,
    party.mobileNumber,
    party.address,
    party.gstin,
    party.pan,
    party.aadhar,
    party.city,
    party.state,
  ];
  return fields.some((f) => {
    if (f == null || f === "") return false;
    const s = String(f);
    if (s.includes(q)) return true;
    if (s.toLowerCase().includes(qLower)) return true;
    return false;
  });
}

/** Match GST number search box */
export function partyMatchesGstSearch(party, query) {
  const q = (query || "").trim().toUpperCase();
  if (!q) return true;
  return String(party.gstin || "").toUpperCase().includes(q);
}

/** GST / Non-GST filter */
export function partyMatchesGstFilter(party, gstFilter) {
  if (!gstFilter || gstFilter === "all") return true;
  const has = partyHasGst(party);
  if (gstFilter === "gst") return has;
  if (gstFilter === "nonGst") return !has;
  return true;
}

/** State dropdown filter */
export function partyMatchesStateFilter(party, stateFilter) {
  const s = (stateFilter || "").trim();
  if (!s) return true;
  const partyState = String(party.state || "").trim();
  if (!partyState) return false;
  if (partyState === s) return true;
  return partyState.toLowerCase().includes(s.toLowerCase()) || s.toLowerCase().includes(partyState.toLowerCase());
}

export function filterParties(
  parties,
  { generalSearch = "", gstSearch = "", gstFilter = "all", stateFilter = "" } = {}
) {
  return (parties || []).filter(
    (p) =>
      partyMatchesGeneralSearch(p, generalSearch) &&
      partyMatchesGstSearch(p, gstSearch) &&
      partyMatchesGstFilter(p, gstFilter) &&
      partyMatchesStateFilter(p, stateFilter)
  );
}

/** Unique states from party list for dropdown */
export function getPartyStateOptions(parties) {
  const set = new Set();
  (parties || []).forEach((p) => {
    const s = (p.state || "").trim();
    if (s) set.add(s);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
}
